import "./styles/theme.css";
import AppRoutes from "./routes/AppRoutes";
import { ToastContainer, OfflineBanner } from "./components/shared/ui";

function App() {
  return (
    <>
      <OfflineBanner />
      <ToastContainer />
      <AppRoutes />
    </>
  );
}

export default App;